import { DeepReadonly, IGlobalCustomDocuments } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const defaultCustomDocuments: DeepReadonly<IGlobalCustomDocuments> = deepFreeze({
  documents: {},
  followUpDocuments: {
    beforeArrivalDocuments: {},
    afterArrivalDocuments: {},
  },
  financeDocuments: {},
});
